<template>
  <section id="admin-filter">
    <h4>Spreadsheet Descriptor Filter</h4>
    <div class="form-group">
      <label for="role-desc" class="form-label">Name</label>
      <input type="text" class="form-control" id="role-desc" v-model="entity.name"/>
    </div>
    <div class="form-group">
      <label for="sdf-prop" class="form-label">Property</label>
      <input type="text" class="form-control" id="sdf-prop" v-model="entity.property"/>
    </div>
    <div class="form-group">
      <label for="sdf-val" class="form-label">Actual Value</label>
      <input type="text" class="form-control" id="sdf-val" v-model="entity.actualValue"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import SheetMixin from './SheetMixin'
  export default {
    name: 'SpreadsheetDescriptorFilter',
    mixins: [ FilterMixin, SheetMixin ],
    data () {
      return {
        entity: {
          name: '',
          entityType: null,
          property: '',
          actualValue: ''
        }
      }
    },
    mounted () {
      this.entity.entityType = this.sheetDescMain
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// SpreadsheetDescriptorFilter.vue?01ed1b1a